// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createStore } from "effector";
import { NewsThemeInfoResponseDTO } from "../../api/backend-openapi";
import {
  deleteNewsTheme,
  setNewsThemes,
  updateNewsTheme
} from "./NewsThemeEvents";

export const NewsThemeStore = createStore<NewsThemeInfoResponseDTO[]>([])
  .on<NewsThemeInfoResponseDTO[]>(
    setNewsThemes,
    (state: NewsThemeInfoResponseDTO[], payload: NewsThemeInfoResponseDTO[]) =>
      payload
  )
  .on<string>(
    deleteNewsTheme,
    (state: NewsThemeInfoResponseDTO[], payload: string) =>
      state.filter(news => news.id !== payload)
  )
  .on<NewsThemeInfoResponseDTO>(
    updateNewsTheme,
    (state: NewsThemeInfoResponseDTO[], payload: NewsThemeInfoResponseDTO) => {
      const index = state.findIndex(news => news.id === payload.id);
      state[index] = payload;
      return [...state];
    }
  );
